import React from "react";
import { FormattedMessage, MessageDescriptor } from "react-intl";

export type ProgressStepState = "completed" | "active" | "danger" | "warning" | "info";

export interface ProgressStep {
    message: MessageDescriptor;
    state: ProgressStepState;
}

interface ProgressStepsProps {
    steps: ProgressStep[];
}

export const ProgressSteps = ({ steps }: ProgressStepsProps) => (
    <ul className="progress-steps">
        {steps.map((step, index) => {
            const className = "progress-steps__step"
                + (step.state != null ? " " + step.state : "");
            return (
                <li className={className} key={index}>
                    <span className="progress-steps__bubble"></span>
                    <FormattedMessage {...step.message} />
                </li>
            );
        })}
    </ul>
);
